export const ENTRYPOINT = `${process.env.REACT_APP_ENTRY_POINT_URL}`;
